<template>
  <div style="height: calc(100% - 36px);">
    <div class="inspection-top">
      <div class="inspection-p">紧急事项({{ priorityTasks.length }})</div>
      <div class="inspection-ul">
        <div :class="task.style" v-for="task in priorityTasks" :key="task.ordinal">
          <div class="text-top">
            <el-checkbox v-model="task.value"
                         true-label="ETV1"
                         false-label="ETV0"
                         :disabled="priorityEnabledOrdinal !== task.ordinal"
                         @click.native.prevent="clickTask(task)">
              {{ task.label || '' }}
            </el-checkbox>
          </div>
          <div class="bbt" v-if="!task.done && priorityEnabledOrdinal === task.ordinal">
            <button class="bt" @click="handleTask(task,'ETV2')">不适用</button>
            <div class="flex">
              <div class="bt2" v-if="showBtnFireDiscover" @click="showFireDiscoverDialog=true">发现火情</div>
              <div class="bt2" v-if="showBtnOocDiscover" @click="showOocDiscoverDialog=true">秩序失控</div>
              <div class="bt2" v-if="showBtnExplosiveDiscover" @click="showExplosiveDiscoverDialog=true">有爆炸物</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="inspection-bottom">
      <div class="inspection-p">待办事项({{ normalTasks.length }})</div>
      <div class="inspection-ul">
        <!--active蓝色  active2灰色  active3绿色-->
        <div :class="task.style" v-for="task in normalTasks" :key="task.ordinal">
          <div class="text-top">
            <el-checkbox v-model="task.value"
                         true-label="ETV1"
                         false-label="ETV0"
                         :disabled="normalEnabledOrdinal !== task.ordinal"
                         @click.native.prevent="clickTask(task)">
              {{ task.label || '' }}
            </el-checkbox>
          </div>
          <div class="bbt" v-if="normalEnabledOrdinal === task.ordinal">
            <div v-if="task.done"></div>
            <button v-else class="bt" @click="handleTask(task,'ETV2')">不适用</button>
            <div class="flex">
              <div class="bt2" v-if="showBtnFireDiscover" @click="showFireDiscoverDialog=true">发现火情</div>
              <div class="bt2" v-if="showBtnOocDiscover" @click="showOocDiscoverDialog=true">秩序失控</div>
              <div class="bt2" v-if="showBtnExplosiveDiscover" @click="showExplosiveDiscoverDialog=true">有爆炸物</div>
            </div>
          </div>
        </div>
      </div>
      <div class="inspection-bt" v-if="['ROLE_ATT','ROLE_SC','ROLE_SCDR'].includes(client)&&taskDoneBtnEnabled" @click="taskDone()">确认秩序已恢复</div>
    </div>
    <fire-discover-dialog v-if="showFireDiscoverDialog" :visible="showFireDiscoverDialog" :type="eventType" :event-id="eventId" @handle-close="showFireDiscoverDialog=false"/>
    <ooc-discover-dialog v-if="showOocDiscoverDialog" :visible="showOocDiscoverDialog" :type="eventType" :event-id="eventId" @handle-close="showOocDiscoverDialog=false"/>
    <explosive-discover-dialog v-if="showExplosiveDiscoverDialog" :visible="showExplosiveDiscoverDialog" :type="eventType" :event-id="eventId" @handle-close="showExplosiveDiscoverDialog=false"/>
  </div>
</template>

<script>
import {chooseTaskAnswerProxy, handleTask, taskDone, taskDoneProxy} from "@/api/kecang";
import OocDiscoverDialog from "@/views/Eventhandling/components/OocDiscoverDialog.vue";
import FireDiscoverDialog from "@/views/Eventhandling/components/FireDiscoverDialog.vue";
import ExplosiveDiscoverDialog from "@/views/Eventhandling/components/ExplosiveDiscoverDialog.vue";

export default {
  components: {ExplosiveDiscoverDialog, FireDiscoverDialog, OocDiscoverDialog},
  props: {
    proxy: {
      type: Boolean,
      default: false
    },
    client: {
      type: String,
      required: true
    },
    eventId: {
      type: String,
      required: true
    },
    eventType: {
      type: String,
      required: true
    },
    done: {
      type: Boolean,
      required: true
    },
    showBtnDiscover: {
      default: false,
      type: Boolean,
      required: false
    },
    taskDoneBtnEnabled: {
      default: false,
      type: Boolean,
      required: false
    },
    dataRows: {
      type: Array,
      required: true
    }
  },
  data() {
    // console.log(['TaskTodoCard data', this.client, this.dataRows])
    return {
      priorityTasks: [],
      normalTasks: [],
      showFireDiscoverDialog: false,
      showOocDiscoverDialog: false,
      showExplosiveDiscoverDialog: false
    }
  },
  mounted() {
    this.setTasks()
  },
  watch: {
    dataRows: {
      deep: true,// true 深度监听
      handler(val, oldVal) {
        // console.log(['TaskTodoCard watch', this.client, this.dataRows])
        this.setTasks()
      }
    }
  },
  computed: {
    priorityEnabledOrdinals() {
      if (this.priorityTasks.length === 0) {
        return [-1]
      }
      const tasks = this.priorityTasks.filter(task => !task.done)
      if (tasks.length > 0) {
        // console.log(['priorityMinOrdinal', tasks[0]])
        const doneOrdinals = this.priorityTasks.filter(task => task.done).map(task => task.ordinal)
        return [tasks[0].ordinal, doneOrdinals.length > 0 ? Math.max(...doneOrdinals) : -1]
      }
      return [Math.max(...this.priorityTasks.filter(task => task.done).map(task => task.ordinal))]
    },
    normalEnabledOrdinals() {
      if (this.priorityTasks.some(task => !task.done)) {
        return [-1]
      }
      const tasks = this.normalTasks.filter(task => !task.done)
      if (tasks.length > 0) {
        // console.log(['priorityMinOrdinal', tasks[0]])
        const doneOrdinals = this.normalTasks.filter(task => task.done).map(task => task.ordinal)
        return [tasks[0].ordinal, doneOrdinals.length > 0 ? Math.max(...doneOrdinals) : -1]
      }
      if (this.eventType === 'CET1') {
        if (!this.taskDoneBtnEnabled) {
          return [-1]
        }
      }
      // if (this.client === 'ROLE_SOC') {
      //   return this.normalTasks.length + 1
      // } else if (['ROLE_SCDR', 'ROLE_ATT', 'ROLE_SC'].includes(this.client)) {
      //   if (this.eventType === 'CET1') {
      //     if (this.taskDoneBtnEnabled) {
      //       return this.normalTasks.length + 1
      //     }
      //   } else {
      //     return this.normalTasks.length + 1
      //   }
      // }
      return [Math.max(...this.normalTasks.filter(task => task.done).map(task => task.ordinal))]
    },
    priorityEnabledOrdinal() {
      return Math.max(...this.priorityEnabledOrdinals)
    },
    normalEnabledOrdinal() {
      return Math.max(...this.normalEnabledOrdinals)
    },
    // 按钮：发现火情
    showBtnFireDiscover() {
      if (['CET0', 'CET5'].includes(this.eventType)) {
        return this.showBtnDiscover || false
      }
      return false
    },
    // 按钮：发现秩序失控
    showBtnOocDiscover() {
      if (['CET1', 'CET2', 'CET4', 'CET5', 'CET6'].includes(this.eventType)) {
        return this.showBtnDiscover || false
      }
      return false
    },
    // 按钮：发现爆炸风险
    showBtnExplosiveDiscover() {
      if (['CET2'].includes(this.eventType)) {
        return this.showBtnDiscover || false
      }
      return false
    },
  },
  methods: {
    async taskDone() {
      if (this.proxy) {
        const res = await taskDoneProxy(this.client, this.eventType, this.eventId)
        if ('A00000' !== res.code) {
          this.$message.error(res.message)
        }
      } else {
        const res = await taskDone(this.eventType, this.eventId)
        if ('A00000' !== res.code) {
          this.$message.error(res.message)
        }
      }
      this.$emit('task-done')
    },
    setTasks() {
      const priorityTasks = this.dataRows.filter(row => row.priority === 'ETP2')
      const normalTasks = this.dataRows.filter(row => row.priority !== 'ETP2')
      priorityTasks.forEach(row => {
        row.style = this.taskResultClass(row)
      })
      normalTasks.forEach(row => {
        row.style = this.taskResultClass(row)
      })
      this.priorityTasks = priorityTasks
      this.normalTasks = normalTasks
    },
    taskResultClass(item) {
      if (item.value) {
        switch (item.value) {
          case 'ETV1':
            return 'inspection-li active3'
          case 'ETV0':
            return 'inspection-li active2'
          default :
            return 'inspection-li active'
        }
      }
      return 'inspection-li'
    },
    async clickTask(task) {
      if (this.priorityEnabledOrdinals.includes(task.ordinal) || this.normalEnabledOrdinals.includes(task.ordinal)){
        switch (task.value) {
          case 'ETV0':
            task.val = 'ETV1'
            break
          case 'ETV1':
          case 'ETV2':
            task.val = 'ETV0'
            break
        }
        this.handleTask(task, task.val)
      }
    },
    async handleTask(task, val) {
      const answer = {
        'eventId': this.eventId,
        'type': this.eventType,
        'value': val,
        'ordinal': task.ordinal
      }
      if (this.proxy) {
        // console.log(['handleTask proxy', task, val])
        const res = await chooseTaskAnswerProxy(this.client, answer)
        if ('A00000' !== res.code) {
          this.$message.error(res.message)
        }
      } else {
        // console.log(['handleTask', task, val])
        const res = await handleTask(answer)
        if ('A00000' !== res.code) {
          this.$message.error(res.message)
        }
      }
    },
  }
};
</script>
<style lang="less">
.inspection-li {
  font-size: 12px;
}
</style>
<style lang="less" scoped>
.inspection-top {
  border-bottom: 1px solid #0F1526;
  height: calc(50% - 90px);
  padding: 16px;
  padding-top: 0;
  text-align: left;

  .inspection-h {
    color: rgba(255, 255, 255, 0.87);
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 20px;
  }
}

.flex {
  display: flex;
  align-items: center;
}

.inspection-bottom {
  padding: 16px;
  height: calc(50% - 20px);

  .inspection-ul {
    height: calc(100% - 40px);
  }
}

.inspection-p {
  opacity: 0.6;
  font-size: 14px;
  text-align: left;
}

.inspection-ul {
  height: calc(100% - 50px);
  overflow: auto;

  .bbt {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 24px;
    margin-top: 12px;
    width: 100%;
    box-sizing: border-box;

    .bt {
      width: 72px;
      height: 26px;
      border: 0.5px solid #6CD8FF;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      margin: 0;
      color: #6CD8FF;
      font-size: 14px;
    }

    .bt2 {
      padding: 0 10px;
      height: 26px;
      border: 0.5px solid #E9463C;
      border-radius: 4px;
      display: flex;
      align-items: center;
      color: #E9463C;
      font-size: 14px;
      justify-content: center;
      margin-left: 15px;
    }
  }

  .inspection-li.text {
    background: #393F52;
    border-radius: 8px;
    padding: 5px;
    height: auto;
    display: block;

    .text-top {
      display: flex;
    }

    .inspection-text {
      border: none;
      overflow: initial; //超出隐藏
      white-space: initial; //不折行
      text-overflow: initial; //溢出显示省略号
      color: rgba(255, 255, 255, 0.87);
      line-height: 24px;
    }
  }

  /deep/ .el-checkbox__label {
      white-space:initial !important;
  }
  /deep/ .inspection-li.active {
    .el-checkbox {
      color: #6CD8FF;
    }

    .el-checkbox__input.is-disabled + span.el-checkbox__label {
      color: #6CD8FF;
    }

    .el-checkbox__inner {
      border-color: #6CD8FF;
      background: #6CD8FF;
    }
  }

  /deep/ .inspection-li.active3 {
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #5CBE85;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background: #5CBE85;
      border-color: #5CBE85;
    }
  }

  /deep/ .inspection-li.active2 {
    /* .el-checkbox__input.is-checked+.el-checkbox__label{
       color: rgba(255, 255, 255, 0.6);
     }*/

    .el-checkbox__input.is-disabled + span.el-checkbox__label {
      color: #606266;
    }
  }

  .inspection-li {
    min-height: 40px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    text-align: left;
    padding: 12px 0;
    box-sizing: border-box;
    border-bottom: 1px solid #2B3245;

    .inspection-icon.active {
      background: url("~@/assets/images/c2.png") no-repeat;
      background-size: 100% 100%;
    }

    .inspection-icon.active2 {
      background: url("~@/assets/images/c3.png") no-repeat;
      background-size: 100% 100%;
    }

    .inspection-icon {
      width: 20px;
      height: 20px;
      background: url("~@/assets/images/c1.png") no-repeat;
      background-size: 100% 100%;
      margin-right: 12px;
    }

    .inspection-text {
      flex: 1;
      color: #5CBE85;
      font-size: 16px;
      overflow: hidden; //超出隐藏
      white-space: nowrap; //不折行
      text-overflow: ellipsis; //溢出显示省略号
      border-bottom: 1px solid #303749;
      height: 100%;
      line-height: 60px;
    }

    .el-checkbox {
      color: #C0C4CC;
      display: flex;
      align-items: flex-start;
    }
  }
}

.inspection-bt {
  height: 44px;
  cursor: pointer;
  background: #1F60C1;
  border-radius: 8px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.87);
  margin-top: 4px;
  position: absolute;
  left: 16px;
  width: calc(100% - 32px);
  bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/Eventhandling/components/TaskTodoCard.vue